/* eslint-disable no-template-curly-in-string -- literal  placeholders that tools/scripts/replace-env-vars.js substitutes before the build */

export const variables = {
  release: '8c006e673545485ca8b0c8865372dc5435cc02ef',
  // Last revision shown in the title-block "Build" cell. Injected in CI; left
  // as the raw `${...}` placeholder locally, where BUILD_INFO falls back.
  commitDate: '2026-10-25T13:24:39+01:00',
  buildTime: '2026-10-25T12:26:11Z',
};
